<div class="space-y-sm">
  @if (levels.length > 0) {
    <cft-holy-grail-grid-sidenav-submenu [levels]="levels"></cft-holy-grail-grid-sidenav-submenu>
  }
  <cft-holy-grail-grid-sidenav-list [level]="level">
    @for (i of items; track i) {
      <li cft-holy-grail-grid-sidenav-list-item [label]="i.label" [path]="i.path"></li>
    }
  </cft-holy-grail-grid-sidenav-list>
</div>
